import {DichVu} from '@/models/dichVu';

export type DongDichVu = Omit<DichVu, 'soThucHien' | 'thoiGianNghi'> & {
  id?: number;
  soThucHien: number | null;
  thoiGianNghi: number | null;
  laCaNhom: boolean;
  soLuong: number;
};

// Suy ra nhóm đầy đủ từ dữ liệu đã lưu, không cần đổi cấu trúc database.
export function gomDichVu(daLuu: DichVu[], danhMuc: DichVu[], nhomMo: number[]): DongDichVu[] {
  const byId = new Map(danhMuc.map(x => [x.dichVu_Id, x]));
  const groups = new Map<number, DichVu[]>();
  const totals = new Map<number, number>();
  byId.forEach(x => totals.set(x.nhomDichVu_Id, (totals.get(x.nhomDichVu_Id) || 0) + 1));
  daLuu.forEach(x => {
    const source = byId.get(x.dichVu_Id);
    const item = {...x, nhomDichVu_Id: source ? source.nhomDichVu_Id : x.nhomDichVu_Id,
      tenNhomDichVu: source ? source.tenNhomDichVu : x.tenNhomDichVu};
    const entries = groups.get(item.nhomDichVu_Id) || [];
    entries.push(item);
    groups.set(item.nhomDichVu_Id, entries);
  });
  const result: DongDichVu[] = [];
  groups.forEach((items, groupId) => {
    const full = groupId > 0 && items.length === totals.get(groupId)
      && items.every(x => byId.has(x.dichVu_Id));
    if (full && !nhomMo.includes(groupId)) {
      const first = items[0];
      result.push({...first, tenDichVu: `Tất cả dịch vụ — ${first.tenNhomDichVu}`,
        soThucHien: items.every(x => x.soThucHien === first.soThucHien) ? first.soThucHien : null,
        thoiGianNghi: items.every(x => x.thoiGianNghi === first.thoiGianNghi) ? first.thoiGianNghi : null,
        laCaNhom: true, soLuong: items.length});
    } else {
      result.push(...items.map(x => ({...x, laCaNhom: false, soLuong: 1})));
    }
  });
  return result;
}
